<template>
    <div class="salesmanmydinddanPage">    
       <XR-head titleText="订单统计" :rightShow="false" ref="headObj"></XR-head>
       <div class="total balance" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
            <div class="sm-info clearfix">
                <p class="sm-info-left">                
                    <span class="fa fa-wechat iconColor"></span> <b>微信号：</b>
                    <em>{{wx}}</em>
                </p>
                <p class="sm-info-right">
                    <a id="erWeiMa" href="/#/salesman/Mycard" title="二维码"><span class="fa fa-qrcode iconColor"></span><b>二维码</b></a>
                </p>
             </div>
        </div>
       <div id="content" class="shop-management">
            <mu-list >
                <mu-list-item >
                    <router-link to="/salesman/orderlist">
                    <div class="mu-item-title">
                         <i class="mu-icon item-icon iconColor fa fa-product"></i>
                        <div class="dd1">
                        <p class="name">店铺订单总数<span style="color: #ccc;">(笔)</span></p>
                        </div>
                        <div class="dd2"><p class="type">{{orderData.TotalCount}}</p></div>
                        </div>
                    </router-link>
                </mu-list-item>
                <mu-list-item >
                    <router-link to="/salesman/orderlist">
                    <div class="mu-item-title">
                        <i class="mu-icon item-icon iconColor fa fa-order2"></i>
                        <div class="dd1">
                        <p class="name">订单总金额</p>
                        </div>
                        <div class="dd2"><p class="type">{{orderData.TotalMoney.toFixed(2)}}</p></div>
                        </div>
                    </router-link>
                </mu-list-item>
                <mu-list-item >
                    <router-link to="/salesman/orderlist">
                    <div class="mu-item-title">
                         <i class="mu-icon item-icon iconColor fa fa-ad"></i>
                        <div class="dd1">
                        <p class="name">已抢店铺订单<span style="color: #ccc;">(笔)</span></p>
                        </div>
                        <div class="dd2"><p class="type">{{orderData.GetCount}}</p></div>
                        </div>
                    </router-link>
                </mu-list-item>
                <mu-list-item >
                    <router-link to="/salesman/orderlist">
                    <div class="mu-item-title">
                         <i class="mu-icon item-icon iconColor fa fa-money7"></i>
                        <div class="dd1">
                        <p class="name">待抢店铺订单<span style="color: #ccc;">(笔)</span></p>
                        </div>
                        <div class="dd2"><p class="type">{{orderData.UnGetCount}}</p></div>
                        </div>
                    </router-link>
                </mu-list-item>
        </mu-list>
       </div>    
     <mu-row class="gutter" >
        <mu-col width="100" tablet="50" desktop="50" class="btn-div">          
          <mu-raised-button label="去抢单" class="submit" primary fullWidth to="/salesman/orderlist" />
        </mu-col>
      </mu-row> 
  </div>
</template>
<script>
export default {
    data(){
        return {
            orderData:{},
            wx:'',
            siteConfig:{ MobileBgImage : '' }
        }
    },
    mounted(){
        this.getSiteInfo()
        this.getOrderData()
        this.getSetting()
    },
    methods:{
        
        getSetting: function(){
            var ths = this;  
            
            ths.$post(
                "/Salesman/SalesmanServer/GetShopSetting"
            ).then(function(res) {
                if(!res.IsSuccess){
                ths.$refs.XRtoast.failed(res.Msg, true)
                }else{
                ths.wx = res.Data.WxNo
                }
            });
        },
        getOrderData(){               
            const ths = this;
            this.$post("/Salesman/RetailServer/GetSalesmanOrderTotal")
            .then(function(res) {
                if (res.IsSuccess) {
                    ths.loaded = false;
                    
                    ths.orderData = res.Data

                    ths.$refs.XRtoast.hide();
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        
        getSiteInfo: function () {    
            const ths = this;
            this.$post('/Shop/SiteConfigServer/GetSiteConfig')
                .then(function (res) {
                if(res.IsSuccess){
                    ths.siteConfig = res.Data
                }         
            })
            .catch(function (err) {
                console.log(err)
            })    
        },         
        
    }
}
</script>

<style>
        body .salesmanmydinddanPage{
            background: #fff;
        }
        .salesmanorderdeliveryPage .sm-top{
	        background-size: 100% 100%;
        }
        salesmanmydindan .sm-top-point{
	        padding-top:3.1rem;
	        position: relative;
	        z-index: 2;	        
	        background-image: url(/styles/assets/images/center_top_bg.png);
	        background-size: cover;
        }

        .salesmanmydinddanPage #content{
            margin-top: 10px;
            background: #fff; 
        }
        .salesmanmydinddanPage .total {
            overflow: hidden;
            padding: 30px;
            background: url("/static/us-top-bg.png");
            background-size: 100% 100%;
        }
        .salesmanmydinddanPage .sm-top-info{
	        z-index: 1;
	        width:100%;
	        height:2rem;
	        bottom: 0;
	        color:#fff;
	        font-size: .875rem;
	        line-height: 2rem;
	        background-color: #5c546b;
	        position: relative;
	        overflow: hidden;
        }
        .salesmanmydinddanPage .sm-top-round{
	        width:5.6rem;
	        height: 1.8rem;
	        padding:1.8rem 0 0;
	        position: absolute;
	        left:50%;
	        bottom: .2rem;
	        margin-left:-2.8rem;
	        border-radius: 0 0 2.8rem 2.8rem;
	        text-align: center;
	        font-size: .75rem;
	        line-height: 1.3;
	        background-color: #ef8569;
        }
        .salesmanmydinddanPage .iconColor{
            color: #757575;
        }
        .salesmanmydinddanPage .sm-top-import{
	        width:50%;
	        box-sizing: border-box;
	        padding-right:2.8rem;
	        float:left;
	        text-align: right;
        }
        .salesmanmydinddanPage .sm-top-out{
	        width:50%;
	        padding-left:2.8rem;
	        box-sizing: border-box;
	        float:right;
	        background-color: #ef8569;
        }

        .salesmanmydinddanPage .sm-info{
	        padding:.5rem;
          height: 60px;
        }
        .salesmanmydinddanPage .sm-info-left{
	        float:left;
	        width:55%;
	        margin:.5rem 0 .5rem 0; 
	        box-sizing: border-box;
            border-right: 1px solid #fff;
	        padding-right: 1rem;
	        font-size: .75rem;
	        line-height: 1.4;
	        color:#5A5655;
	        text-align: right;
        }
        .sm-info-left span,.sm-info-left b,.sm-info-right span,.sm-info-right b{
            color: #fff;
        }
        .salesmanmydinddanPage .sm-info-left em{
            font-style: normal;
            color: #fff;
	        display: block;
            margin-top:3px; 
        }
        .salesmanmydinddanPage .sm-info-left i{
	        color:#47A859;
        }
        .salesmanmydinddanPage .sm-info-middle b
        {
            line-height: 1.4;
	        margin-left:-.75rem;
	        display: block;
            color: #fff;
	        font-size: .75rem;   
        }
        .salesmanmydinddanPage .sm-info-right{
	        float:left;
	        width:45%;
	        box-sizing: border-box;
	        padding:.5rem 0 .5rem 1.5rem; 
        }
        .salesmanmydinddanPage .sm-info-right a{
	        font-size: .75rem;
	        line-height: 1;
            color: black;
        }
        .salesmanmydinddanPage .sm-info-right a i{
	        font-size: 1.5rem;
	        line-height: 1;
	        display: block;
        }
        .salesmanmydinddanPage .sm-info-right a b{
	        line-height: 1.4;
	        margin-left:-.3rem;
	        display: block;
	        font-size: .75rem;
        }
        .salesmanmydinddanPage .mu-item{
            margin-left:24px;
            padding-left: 0px; 
            border-bottom: 1px solid #eee; 
        }
       .salesmanmydinddanPage .item-icon{
             width: 15%;
             float: left;
             font-size: 20px;
             text-align: left;
         }
       .salesmanmydinddanPage .dd1
        {
            float:left;
            width:65%;
            text-align:left;
            font-size:13px;
        }
        .salesmanmydinddanPage .dd1 .name { color: #474a4f; font-size:16px; vertical-align: center;}
        .salesmanmydinddanPage .dd2
        {
            float: right;;
            width:20%;
            text-align:center;
            padding-left:2%;
            font-size:12px;
        }
        .salesmanmydinddanPage .dd2 .type { color: #ef8569; font-size:15px;}
        .salesmanmydinddanPage .gutter{
           padding: 40px 5% 30px;
        }
        .salesmanmydinddanPage .submit {
            height: 50px;
        }
    </style>



// WEBPACK FOOTER //
// src/pages/salesman/mydingdan.vue